import { z } from 'zod';
import { paginationResponseSchema } from './common.schemas';

/**
 * Audit Trail & Governance Schemas
 */

// Audit log entry
export const auditLogSchema = z.object({
  id: z.string().uuid(),
  action: z.string(),
  actorType: z.enum(['user', 'agent', 'system']),
  actorId: z.string().nullable(),
  targetType: z.string().nullable(),
  targetId: z.string().nullable(),
  details: z.record(z.unknown()),
  decision: z.string().nullable(), // XAI decision made
  reasoning: z.string().nullable(), // XAI reasoning
  rbacCheck: z.record(z.unknown()).nullable(), // RBAC permissions verified
  ipAddress: z.string().nullable(),
  userAgent: z.string().nullable(),
  timestamp: z.coerce.date(),
  organizationId: z.string().uuid(),
  userId: z.string().uuid().nullable(),
  agentActionId: z.string().uuid().nullable(),
});

// Audit log filters
export const auditLogFiltersSchema = z.object({
  action: z.string().optional(),
  actorType: z.enum(['user', 'agent', 'system']).optional(),
  actorId: z.string().optional(),
  targetType: z.string().optional(),
  targetId: z.string().optional(),
  fromDate: z.coerce.date().optional(),
  toDate: z.coerce.date().optional(),
});

// Audit log list response
export const auditLogListResponseSchema = z.object({
  logs: z.array(auditLogSchema),
  pagination: paginationResponseSchema,
});

// RBAC permission check
export const rbacPermissionSchema = z.object({
  resource: z.string(),
  action: z.string(),
  allowed: z.boolean(),
  reason: z.string().optional(),
});

// Export audit log
export const exportAuditLogSchema = z.object({
  format: z.enum(['json', 'csv']),
  filters: auditLogFiltersSchema.optional(),
});

// Export inferred types
export type AuditLog = z.infer<typeof auditLogSchema>;
export type AuditLogFilters = z.infer<typeof auditLogFiltersSchema>;
export type AuditLogListResponse = z.infer<typeof auditLogListResponseSchema>;
export type RBACPermission = z.infer<typeof rbacPermissionSchema>;
export type ExportAuditLogInput = z.infer<typeof exportAuditLogSchema>;
